import { Routes } from '@angular/router';
import { Collect } from '@components/page/collect/collect';
import { Menu } from '@services/menu.service';
import { BinderList } from '@components/partials/collect/binder-list/binder-list';
import { CardList } from '@components/partials/collect/card-list/card-list';
import { FavoriteList } from '@components/partials/collect/favorite-list/favorite-list';
import { Binder } from '@components/page/binder/binder';
import { Card } from '@components/page/card/card';
import { Cgv } from '@components/page/cgv/cgv';
import { UserList } from '@components/admin/user-list/user-list';
import { hasRightGuard } from '@guards/admin.guards';
import { Scrap } from '@components/admin/scrap/scrap';
import { SetScraping } from '@components/admin/set-scraping/set-scraping';
import { CardTool } from '@components/admin/cards/card-tool/card-tool';
import { CardList as AdminCardList } from '@components/admin/cards/card-list/card-list';
import { CardIndex as CardIndexAdmin } from '@components/admin/cards/card-index/card-index';
import { CardForm } from '@components/admin/cards/card-form/card-form';
import { BinderAdminList } from '@components/admin/binders/binder-admin-list/binder-admin-list';
import { BinderAdminForm } from '@components/admin/binders/binder-admin-form/binder-admin-form';
import { OpenBinder } from '@components/page/open/open-binder/open-binder';
import { CardBinderForm } from '@components/page/card-binder-form/card-binder-form';
import { ShareList } from '@components/page/share-list/share-list';
import { PageBinder } from '@components/page/page-binder/page-binder';
import { TypeCardStat } from '@components/page/stats/type-card-stat/type-card-stat';
import { StatsCard } from '@components/page/stats/stats-card/stats-card';
import { StatsOverview } from '@components/page/stats/stats-overview/stats-overview';
import { StatsSerieList } from '@components/page/stats/stats-serie-list/stats-serie-list';
import { StatsSerie } from '@components/page/stats/stats-serie/stats-serie';
import { CardSearch } from '@components/page/card-search/card-search';
import { CardIndex } from '@components/page/card-index/card-index';
import { Shop } from '@components/page/shop/shop/shop';
import { Offers } from '@components/page/licence/offers/offers';
import { PaymentSuccess } from '@components/shop/payment/payment-success/payment-success';
import { PaymentFailed } from '@components/shop/payment/payment-failed/payment-failed';
import { PlanPayment } from '@components/shop/plan-payment/plan-payment';
import { UserOptions } from '@components/page/user/user-options/user-options';
import { Login } from '@components/page/user/login/login';
import { Forgot } from '@components/page/user/forgot/forgot';
import { Sign } from '@components/page/user/sign/sign';
import { Apikeys } from '@components/admin/api/apikeys/apikeys';
import { ProxiesList } from '@components/admin/proxies/proxies-list/proxies-list';
import { ProxyForm } from '@components/admin/proxies/proxy-form/proxy-form';
import { Cgu } from '@components/page/cgu/cgu';
import { SetUp } from '@components/page/set-up/set-up';


/*
 * data: {
 * 	name: 	string		=> nom de la route
 * 	menu?: 	string, 	=> type de menu
 * }
 * 
 * 
 */
export const routes: Routes=[
	{path: '', pathMatch: 'full', redirectTo: 'collect/binders', data: {name: 'home'}},
	{path: 'collect', component: Collect, children: [
		{path: '', pathMatch: 'full', redirectTo: 'binders', data: {name: 'collect-home'}},
		{path: 'binders', component: BinderList, data: {name: 'collect-binders'}},
		{path: 'cards', component: CardList, data: {name: 'collect-cards'}},
		{path: 'favorites', component: FavoriteList, data: {name: 'collect-favorites'}},
	]},
	{path: 'connect/binders/open', component: OpenBinder, data: {name: 'collect-open-start'}},
	{path: 'open/:id', component: OpenBinder, data: {data: 'collect-opentcode'}},
	{path: 'collect/binders/:ident', component: Binder, data: {name: 'collect-binder'}},
	{path: 'collect/cards/:ident', component: Card, data: {name: 'collect-card'}},
	{path: 'collect/cards/edit/:ident', component: CardBinderForm, data: {name: 'collect-edit-card'}},
	{path: 'conditions-generales-de-vente', component: Cgv, data: {name: 'cgv', menu: Menu.TYPE_NONE, overrideConnect: true}},
	{path: 'conditions-generales-d-utilisation', component: Cgu, data: {name: 'cgu', menu: Menu.TYPE_NONE, overrideConnect: true}},
	{path: 'install', component: SetUp, data: {name: 'instrall', menu: Menu.TYPE_NONE, overrideConnect: true}},
	{path: 'sign', component: Sign, data: {name: 'sign', menu: Menu.TYPE_NONE, overrideConnect: true}},
	{path: 'login', component: Login, data: {name: 'login', menu: Menu.TYPE_NONE}},
	{path: 'forgot', component: Forgot, data: {name: 'forgot', menu: Menu.TYPE_NONE, overrideConnect: true}},
	{path: 'my-acount', component: Sign, data: {name: 'my-acount'}},
	{path: 'my-share', component: ShareList, data: {name: 'my-share'}},
	{path: 'my-options', component: UserOptions, data: {name: 'my-options'}},
	{path: 'admin', children: [
		{path: 'users', component: UserList, canActivate: [hasRightGuard], data: {name: 'admin-user-list', right: 'users'}},
		{path: 'users/:ident', component: Sign, canActivate: [hasRightGuard], data: {name: 'admin-user', right: 'users'}},
		{path: 'scrap', component: Scrap, canActivate: [hasRightGuard], data: {name: 'scrap-home', right: 'scrap'}},
		{path: 'scrap/set/:id', component: SetScraping, canActivate: [hasRightGuard], data: {name: 'scrap-set', right: 'scrap'}},
		{path: 'cards', component: CardTool, children: [
			{path: 'list', component: AdminCardList, canActivate: [hasRightGuard], data: {name: 'admin-card-list', right: 'cards'}},
			{path: 'indexes', component: CardIndexAdmin, canActivate: [hasRightGuard], data: {name: 'admin-card-index', right: 'indexes'}}
		]},
		{path: 'cards/form', component: CardForm, canActivate: [hasRightGuard], data: {name: 'admin-form', right: 'cards'}},
		{path: 'cards/:id', component: CardForm, canActivate: [hasRightGuard], data: {name: 'admin-card', right: 'cards'}},
		{path: 'binders', component: BinderAdminList, canActivate: [hasRightGuard], data: {name: 'admin-binder', right: 'binders'}},
		{path: 'binders/form', component: BinderAdminForm, canActivate: [hasRightGuard], data: {name: 'admin-binder-add', right: 'binders'}},
		{path: 'binders/:id', component: BinderAdminForm, canActivate: [hasRightGuard], data: {name: 'admin-binder-form', right: 'binders'}},
		{path: 'api-keys', component: Apikeys, canActivate: [hasRightGuard], data: {name: 'api-key-list', right: 'api'}},
		{path: 'proxies', component: ProxiesList, canActivate: [hasRightGuard], data: {name: 'proxies-list', right: 'scrap'}},
		{path: 'proxies/add', component: ProxyForm, canActivate: [hasRightGuard], data: {name: 'proxy-add', right: 'scrap'}},
		{path: 'proxies/:ident', component: ProxyForm, canActivate: [hasRightGuard], data: {name: 'proxy-form', right: 'scrap'}}
	]},
	{path: 'shares', children:[
		{path: 'binders/:ident', component: Binder, data: {name: 'share-binder', menu: Menu.TYPE_NONE, overrideConnect: true}},
		{path: 'cards/:ident', component: Card, data: {name: 'share-card', menu: Menu.TYPE_NONE, overrideConnect: true}},
		{path: 'pages/:ident', component: PageBinder, data: {name: 'share-page', menu: Menu.TYPE_NONE, overrideConnect: true}}
	]},
	{path: 'stats', children: [
		{path: '', pathMatch: 'full', redirectTo: 'types', data: {name: 'stat-home'}},
		{path: 'types', component: TypeCardStat, data: {name: 'stat-type'}},
		{path: ':type', component: StatsCard, children:[
			{path: 'series', component: StatsSerieList, data: {name: 'stat-series'}},
			{path: 'overview', component: StatsOverview, data: {name: 'stat-overview'}},
		]},
		{path: 'card-sets/:cardSet', component: StatsSerie, data: {name: 'stat-serie'}}
	]},
	{path: 'cards/search', component: CardSearch, data: {name: 'card-search'}},
	{path: 'cards/:ident', component: CardIndex, data: {name: 'card-index'}},
	{path: 'subscriptions', children: [
		{path: 'offers', component: Offers, data: {name: 'licence-offers'}},
		{path: 'payments/checkout', component: PlanPayment, data: {name: 'plan-checkout'}}
	]},
	{path: 'orders/payments/success', component: PaymentSuccess, data: {name: 'payment-success'}},
	{path: 'orders/payments/failed', component: PaymentFailed, data: {name: 'payment-failed'}},


	/* a définir */
	{path: 'shop', component: Shop, data: {name: 'shop'}}
];